<template>
    <div>
        <header class="bg-white shadow">
            <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8">
                <div class="relative h-16 flex justify-between">
                    <div class="relative z-10 px-2 flex lg:px-0">
                        <div class="flex-shrink-0 flex items-center">
                            <inertia-link :href="$route('home')">
                                <img alt="Logo" class="block h-8 w-auto" src="/images/logo.png" />
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="max-w-7xl mx-auto pb-10">
            <slot />
        </main>
    </div>
</template>

<script>
    export default {
        data: () => ({ }),

        methods: { },
    };
</script>
